
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { productsData } from '../../../mocks/products';
import Button from '../../../components/base/Button';

export default function ProductsCatalog() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'alarms', name: 'Fire Alarms' },
    { id: 'extinguishers', name: 'Fire Extinguishers' },
    { id: 'sprinklers', name: 'Sprinkler Systems' },
    { id: 'lighting', name: 'Emergency Lighting' }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? productsData 
    : productsData.filter(product => product.category === selectedCategory);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap min-h-[44px] ${
                selectedCategory === category.id
                  ? 'bg-brand-red text-white'
                  : 'bg-white text-brand-blue border-2 border-brand-blue hover:bg-brand-blue hover:text-white'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {filteredProducts.map((product) => (
            <div key={product.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-200 hover:border-brand-red/25">
              <Link to={`/products/${product.slug}`} className="block">
                <div className="aspect-square overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
              </Link>
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="bg-brand-red text-white px-3 py-1 rounded-full text-sm font-medium">
                    {product.compliance}
                  </span>
                  <span className="text-brand-blue text-sm font-medium capitalize">{product.category}</span>
                </div>
                <Link to={`/products/${product.slug}`}>
                  <h3 className="text-xl font-semibold text-brand-blue mb-3 hover:text-brand-red transition-colors duration-300 line-clamp-2">
                    {product.name}
                  </h3>
                </Link>
                <p className="text-gray-600 mb-4 line-clamp-3 text-base leading-relaxed">
                  {product.shortDescription}
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link to={`/products/${product.slug}`} className="flex-1">
                    <Button size="sm" className="w-full">
                      View Details
                    </Button>
                  </Link>
                  <Button variant="outline" size="sm" className="flex-1">
                    <i className="ri-mail-line mr-2"></i>
                    Quote
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-search-line text-6xl text-gray-400 mb-4"></i>
            <h3 className="text-xl font-semibold text-gray-600 mb-2">No products found</h3>
            <p className="text-gray-500">Try selecting a different category.</p>
          </div>
        )}
      </div>
    </section>
  );
}
